module.exports = __webpack_public_path__ + "img/协同工作.1614adbf.png";